/* @flow */

type State = {
    states: Object
};

let initialState = { states: {} };
export function loading(state: State = initialState, action:Object): State {
    let matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(action.type);
    if(matches) {
        let newState = {...state};
        newState.states = {...newState.states};

        newState.states[matches[1]] = matches[2];

        return newState;
    } else {
        return state;
    }
}
